import { render } from "./CreateOrUpdateUserOrganizationModal.vue?vue&type=template&id=9010680e"
import script from "./CreateOrUpdateUserOrganizationModal.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateUserOrganizationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__